import c from "../common";

export default {
  SmsMsg: c.appName.chn + "新用户您好, 您的驗證碼: ",

  Step1_title: "電郵認證",
  Step2_title: "帳户資料",
  Step3_title: "雙重認證",

  FirstTimeWarning: "如首次註冊, 請使用電腦及預備您的手機作雙重認證之用",
  PhoneReady: "請準備您的手提電話作認證之用",

  "Sent-Msg_1.1": "我們已向",
  "Sent-Msg_1.2": " 發送驗證碼短訊",
  "Sent-Msg_1.3": "驗證碼不正確",

  "Sent-Msg_2.1": "帳號已經存在, 無須重複註冊",
  "Sent-Msg_2.3": "立即登入",

  Email_alert: "電郵已被使用,請重新輸入",
  Email_alert2: "重新輸入",

  MobilePhone: "電話 (選填)",
  phone_rule1: "請輸入8位電話",
  phone_rule2: "電話只可包含數字",
  phone_rule3: "不可含有空格",

  getPin: "取得驗證碼",
  second: "秒",

  V_Code: c.V_Code.chn + "：",
  Pin_rule1: "請輸入4位數字",
  Pin_rule2: "只可包含數字",
  Confirm: c.Confirm.chn,

  NamePIC: "用戶名稱：",
  entername: "請輸入名稱",

  emailPIC: "電郵：",
  enterEmail: "請輸入正確電郵",

  pwPIC: "密碼：",
  enterPw: "請輸入9至16位密碼",
  rule_pw: "不可含有空格",

  repeatPw: "重複密碼",
  reEnterPw: "請重複輸入密碼",
  unmatchPw: "您輸入的兩個密碼不匹配",

  step1: "1. 下載 Google Authenticator 應用程式",
  step2: "2. 設立帳户",
  step3: "3. 確認驗證碼",
  step4: "4. 完成",
  mustdo: "*必需下載及安裝",

  GAtitle: "Google Authenticator 商店下載鏈結",
  withphone: "(*請使用手機掃描QR Code下載)",

  LinkTitleAnd: " Google Play 下載鏈結 (Andriod)",
  LinkTitleIos: " App Store 下載鏈結 (IOS) ",

  "step1-2": " 下載 Google Authenticator ",
  "1-2GP": "於Google Play 點擊按鈕下載",
  "1-2AS": "於App Store 點擊按鈕下載",

  next: c.next.chn,
  previous: c.previous.chn,

  //2FA step2
  "step2-1": "1. 打開 Google Authenticator",
  "step2-2": "2. 點擊「Get started」開始使用 ",
  "step2-3": "3. 點擊「Scan a QR code」打開掃描器 ",

  //2FA step3
  "step3-1": "1. 掃描你的金鑰 ",
  "step3-1hide": "隱藏",
  "step3-1show": "顯示",
  "step3-1generate": "生成金鑰",

  "step3-2": "2. 請輸入 「" + c.appName.chn + "」 下的6位數字",
  "step3-2wrong": "驗證碼不正確",
  "step3-2req": "請輸入6位數字",
  "step3-2rule": "只可包含數字",

  //2FA step4 (complete page)
  CompleteAC: "已成功註冊！",
  OpenAcNow: "立即開設商戶",
  EnterDash: "進入主頁",

  description_1: "歡迎您加入" + c.appName.chn,
  description_2: c.appName.chn,
};
